import { createAsyncThunk } from '@reduxjs/toolkit';

import { EmbeddableService } from '../../services';

export const fetchEmbeddableToken = createAsyncThunk(
  'embeddable/fetchEmbeddableToken',
  async (reportName, { rejectWithValue }) => {
    try {
      const response = await EmbeddableService.fetchEmbeddableToken(reportName);

      return response?.data?.token;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch embeddable token.');
    }
  }
);
